import React, { useState } from 'react';
import { Search, AlertTriangle, Shield, UserX, MessageSquare, CheckCircle } from 'lucide-react';
import { mockConversations } from '../../data/mockData';
export const MessagingModeration = () => {
  const [activeConvId, setActiveConvId] = useState(mockConversations[0].id);
  const activeConv = mockConversations.find(c => c.id === activeConvId) || mockConversations[0];
  return <div className="h-[calc(100vh-8rem)] flex flex-col animate-in fade-in" data-id="element-765">
      <div className="mb-6 flex items-center justify-between" data-id="element-766">
        <div data-id="element-767">
          <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-768">
            Messaging Moderation
          </h1>
          <p className="text-slate-500 dark:text-slate-400" data-id="element-769">
            Monitor communications for fraud and policy violations.
          </p>
        </div>
        <div className="flex gap-2" data-id="element-770">
          <div className="px-3 py-1.5 bg-red-100 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 rounded-lg flex items-center gap-2 text-red-600 dark:text-red-400 text-sm font-bold" data-id="element-771">
            <AlertTriangle size={16} data-id="element-772" /> 3 Flagged Chats
          </div>
        </div>
      </div>

      <div className="flex-grow flex gap-6 overflow-hidden" data-id="element-773">
        {/* Left Panel: Conversations */}
        <div className="w-1/3 bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 flex flex-col overflow-hidden shrink-0" data-id="element-774">
          <div className="p-4 border-b border-slate-200 dark:border-slate-700" data-id="element-775">
            <div className="relative" data-id="element-776">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500" size={18} data-id="element-777" />
              <input type="text" placeholder="Search users or keywords..." className="w-full pl-10 pr-4 py-2 rounded-lg bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white text-sm focus:ring-2 focus:ring-secondary outline-none" data-id="element-778" />
            </div>
          </div>

          <div className="flex-grow overflow-y-auto custom-scrollbar" data-id="element-779">
            {mockConversations.map((conv, idx) => <div key={conv.id} onClick={() => setActiveConvId(conv.id)} className={`p-4 border-b border-slate-100 dark:border-slate-700/50 cursor-pointer transition-colors flex gap-3 ${activeConvId === conv.id ? 'bg-slate-50 dark:bg-slate-800/80 border-l-4 border-l-secondary' : 'hover:bg-slate-50 dark:hover:bg-slate-800/50 border-l-4 border-l-transparent'}`} data-id="element-780">
                <div className="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-white flex items-center justify-center font-bold shrink-0" data-id="element-781">
                  {conv.participant.avatar}
                </div>
                <div className="flex-grow min-w-0" data-id="element-782">
                  <div className="flex justify-between items-start mb-1" data-id="element-783">
                    <h4 className="font-bold text-sm text-slate-900 dark:text-slate-200 truncate" data-id="element-784">
                      {conv.participant.name}
                    </h4>
                    {idx === 0 && <AlertTriangle size={14} className="text-red-500 dark:text-red-400 shrink-0" data-id="element-785" />}
                  </div>
                  <p className="text-xs text-slate-500 dark:text-slate-400 truncate" data-id="element-786">
                    {conv.lastMessage}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Main Panel: Chat Preview */}
        <div className="flex-grow bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 flex flex-col overflow-hidden" data-id="element-787">
          <div className="p-4 border-b border-slate-200 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-800/30" data-id="element-788">
            <div className="flex items-center gap-3" data-id="element-789">
              <div className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-white flex items-center justify-center font-bold" data-id="element-790">
                {activeConv.participant.avatar}
              </div>
              <div data-id="element-791">
                <h3 className="font-bold text-slate-900 dark:text-white" data-id="element-792">
                  Buyer: John Doe ↔ Seller: {activeConv.participant.name}
                </h3>
                <p className="text-xs text-slate-500 dark:text-slate-400" data-id="element-793">
                  Property: {activeConv.property.title}
                </p>
              </div>
            </div>
          </div>

          <div className="flex-grow overflow-y-auto p-6 space-y-6 custom-scrollbar bg-slate-50 dark:bg-slate-900/50" data-id="element-794">
            {activeConv.messages.map((msg, idx) => {
            const isBuyer = msg.sender === 'me';
            // Mock a flagged message
            const isFlagged = idx === 1;
            return <div key={msg.id} className={`flex flex-col ${isBuyer ? 'items-end' : 'items-start'}`} data-id="element-795">
                  <div className="flex items-center gap-2 mb-1" data-id="element-796">
                    <span className="text-xs font-bold text-slate-500" data-id="element-797">
                      {isBuyer ? 'John Doe' : activeConv.participant.name}
                    </span>
                    <span className="text-[10px] text-slate-400 dark:text-slate-600" data-id="element-798">
                      {msg.time}
                    </span>
                  </div>
                  <div className={`max-w-[70%] p-3 rounded-2xl ${isFlagged ? 'bg-red-100 border border-red-200 text-red-700 dark:bg-red-500/10 dark:border-red-500/30 dark:text-red-200' : isBuyer ? 'bg-slate-800 text-white dark:bg-slate-700 dark:text-slate-200 rounded-tr-sm' : 'bg-white border border-slate-200 text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-300 rounded-tl-sm'}`} data-id="element-799">
                    <p className="text-sm" data-id="element-800">{msg.text}</p>
                    {isFlagged && <div className="mt-2 pt-2 border-t border-red-200 dark:border-red-500/20 text-[10px] font-bold text-red-600 dark:text-red-400 flex items-center gap-1" data-id="element-801">
                        <AlertTriangle size={12} data-id="element-802" /> Flagged: Off-platform
                        payment request detected
                      </div>}
                  </div>
                </div>;
          })}
          </div>
        </div>

        {/* Right Panel: Moderation Actions */}
        <div className="w-1/4 bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6 flex flex-col shrink-0" data-id="element-803">
          <h3 className="font-bold text-slate-900 dark:text-white mb-6" data-id="element-804">
            Moderation Actions
          </h3>

          <div className="space-y-4" data-id="element-805">
            <button className="w-full py-3 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-600 rounded-xl text-sm font-bold flex items-center gap-3 transition-colors" data-id="element-806">
              <MessageSquare size={18} className="text-blue-500 dark:text-blue-400" data-id="element-807" />{' '}
              Send Warning
            </button>
            <button className="w-full py-3 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-600 rounded-xl text-sm font-bold flex items-center gap-3 transition-colors" data-id="element-808">
              <Shield size={18} className="text-yellow-500 dark:text-yellow-400" data-id="element-809" />{' '}
              Block Conversation
            </button>
            <button className="w-full py-3 bg-red-50 dark:bg-red-500/10 hover:bg-red-100 dark:hover:bg-red-500/20 text-red-600 dark:text-red-400 border border-red-200 dark:border-red-500/20 rounded-xl text-sm font-bold flex items-center gap-3 transition-colors" data-id="element-810">
              <UserX size={18} data-id="element-811" /> Suspend User
            </button>
          </div>

          <div className="mt-8 pt-8 border-t border-slate-200 dark:border-slate-700" data-id="element-812">
            <h4 className="font-bold text-slate-700 dark:text-slate-300 text-sm mb-4" data-id="element-813">
              Resolution Status
            </h4>
            <button className="w-full py-3 bg-emerald-50 dark:bg-emerald-500/10 hover:bg-emerald-100 dark:hover:bg-emerald-500/20 text-emerald-600 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-500/20 rounded-xl text-sm font-bold flex items-center justify-center gap-2 transition-colors" data-id="element-814">
              <CheckCircle size={18} data-id="element-815" /> Mark as Resolved
            </button>
          </div>
        </div>
      </div>
    </div>;
};